import React, { useState, useCallback, useEffect } from 'react';
import Formfield from '../components/FormField';
import CustomButton from '../components/CustomButton';
import Message from '../components/Message';

const Contact = () => {
  const [form, setForm] = useState({
    Individual_name: '',
    email: '',
    description: '',
    project_name: ''
  });

  const [message, setMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const API_URL = process.env.NODE_ENV === 'production' 
    ? 'https://portfolio-backend-ppn6.onrender.com/api/contact'
    : 'http://localhost:5000/api/contact';

  const checkAPIHealth = useCallback(async () => {
    try {
      const response = await fetch(API_URL.replace('/api/contact', '/api/health'));
      const data = await response.json();
      console.log('API Health Check:', data);
    } catch (error) {
      console.error('API Health Check Failed:', error);
    }
  }, [API_URL]);

  useEffect(() => {
    console.log('Current API_URL:', API_URL);
    checkAPIHealth();
  }, [API_URL, checkAPIHealth]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(null); 
    try {
      console.log('Submitting form:', form);
      console.log('Submitting to URL:', API_URL);
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Origin': 'https://mutegimutugi.vercel.app'  // Removed trailing slash
        },
        body: JSON.stringify(form)
      });
  
      console.log('Response status:', response.status);
      console.log('Response headers:', Object.fromEntries(response.headers));

      const data = await response.json();
      console.log('Response data:', data);
  
      if (response.ok) {
        setMessage({ type: 'success', text: data.message });
        setForm({
          Individual_name: '',
          email: '',
          description: '',
          project_name: ''
        });
      } else {
        setMessage({ type: 'error', text: data.message || 'An error occurred. Please try again.' });
      }
    } catch (error) {
      console.error('Submission error:', error);
      setMessage({ type: 'error', text: 'Form submission failed. Please check your connection and try again.' });
    } finally {
      setIsSubmitting(false);
    }
  }, [form, API_URL]);

  const handleFormFieldChange = useCallback((fieldName, e) => {
    setForm(prevForm => ({ ...prevForm, [fieldName]: e.target.value }));
  }, []);

  return (
    <div className='flex flex-col items-center ml-0 lg:ml-[17em] mt-3 lg:mt-[0] justify-center min-h-screen overflow-x-hidden pb-[1em] px-7 lg:px-0'>
      <div className='flex flex-row h-full w-full mt-12'>
        <div className='flex flex-col items-center w-full lg:w-[100%]'>
          {message && (
            <Message type={message.type} text={message.text} />
          )}
          <form onSubmit={handleSubmit} className='flex flex-col gap-4 w-full lg:w-[80%] pb-8'>
            <Formfield
              LabelName='Name'
              placeholder='Enter your name'
              inputType='text'
              value={form.Individual_name}
              handleChange={(e) => handleFormFieldChange('Individual_name', e)}
              required
            />
            <Formfield
              LabelName='Email'
              placeholder='Enter your email'
              inputType='email'
              value={form.email}
              handleChange={(e) => handleFormFieldChange('email', e)}
              required
            />
            <Formfield
              LabelName='Inquiry Name'
              placeholder='Enter your Inquiry Topic'
              inputType='text'
              value={form.project_name}
              handleChange={(e) => handleFormFieldChange('project_name', e)}
              required
            />
            <Formfield
              LabelName='Description'
              placeholder='Enter your description'
              isTextArea
              value={form.description}
              handleChange={(e) => handleFormFieldChange('description', e)}
              required
            />
            <div className='flex justify-center items-center mt-4'>
              <CustomButton
                btnType='submit'
                title={isSubmitting ? 'Submitting...' : 'Submit Form'}
                styles='border border-black font-suwannaphum text-black hover:bg-gray-400'
                disabled={isSubmitting}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;